import { BasePostProvider } from "@tendercuts/http";
import { EndPoint } from "../base";
import { Injectable } from "@angular/core";
import { LoginServices } from "../login";
import { GenericServerResponse } from "@tendercuts/models";
import "rxjs/add/operator/map";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class ReSendOtpService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get model() {
    return GenericServerResponse;
  }

  get isAuthenticatedEndpoint() {
    return false;
  }

  get authProtocol() {
    return null;
  }

  /**
   * @override
   * Disable caching for this service as we want OTP to be generated everytime
   */
  get isCachable() {
    return false;
  }

  get endpoint() {
    return this.endpointService.reSendOtp();
  }

  getParams(otpType: string, phone: string) {
    const params = {
      mobile: phone,
      retry_mode: otpType,
    };

    return params;
  }
}
